;(function($) {
    $('[data-href]:not([data-href=""])')
        .each(function() {
            var $this = $(this), url = $this.data('href');

            if ($this.prop("tagName") == 'A') {
                $this.data('href', null);
                $this.attr('href', url);
            }
        });
})(jQuery);